// src/pages/dashboard/BotLogs.jsx
import React from 'react';

const sampleLogs = [
  "🟢 Buy order executed: BTC @ $67,120.00",
  "🔁 Strategy changed to Grid Mode",
  "📤 Sell order triggered: ETH @ $3,480.50",
  "⏸️ Bot paused for manual override",
  "✅ Profit booked: +$28.60",
];

const BotLogs = () => {
  return (
    <div className="bg-[#0B3A32] p-6 rounded-xl shadow-lg">
      <h2 className="text-xl font-semibold text-[#CE9242] mb-4">📋 Bot Activity Logs</h2>

      <div className="bg-[#062925] p-4 rounded-md text-sm text-gray-300 max-h-[300px] overflow-y-auto space-y-2">
        {sampleLogs.map((log, index) => (
          <div key={index} className="border-b border-[#1a4c46] pb-2">{log}</div>
        ))}
      </div>
    </div>
  );
};

export default BotLogs;
